import type { ApiCursorBody, ApiResponse } from '@/types/api-response.types'
import type { Faq } from '@/types/faq.types'
import api from '../axios'

export const faqService = {
  async getFaqs(cursor: number | null, size: number, { ascending = false }): Promise<ApiCursorBody<Faq>> {
    const response: ApiResponse<ApiCursorBody<Faq>> = await api.get('/v1/faq', {
      params: {
        cursor,
        size,
        ascending,
      },
    })
    return response.body
  },
}
